import Alert from './alert.vue'
export default Alert



// WEBPACK FOOTER //
// ./src/components/alert/index.js